import React from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import ScheduleGrid from "../../components/Schedules/ScheduleGrid";
import Toolbar from "../../components/Toolbar/Toolbar";

const SchedulesIndex = ({classes, subjects, course}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={ i18n.get('schedules.heading_schedule', {course: course.name})}
            subtitle={`${subjects.length} ${i18n.get('schedules.number_of_subjects')}`}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('schedules.new_subject'),
                    href: `/schedules/${course.id}-${course.name_short}/create`,
                }
            ]}
        />

        <ScheduleGrid subjects={subjects}/>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(SchedulesIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/schedules/Index.jsx